module.exports = __webpack_public_path__ + "img/kaoqintongji.ae0aa0aa.png";